<div class="mb-3">
  <h1 class="fs-5 fw-bold mb-0">Conversion Event Log</h1>
</div>

<div class="card border-0 shadow mb-3 fade-in-zoom">
  <div class="card-header fw-bold bg-tertiary p-3 border-0">
    <h2 class="fs-6 fw-bold mb-0"><i class="bi bi-filter me-2 text-primary"></i>Filters</h2></div>
    <div class="card-body">

      <app-log-filters [filters]="filters" (init)="fetchAll()" [hasLandingPage]="false"></app-log-filters>

      <div class="row g-3 align-items-end mb-4">
        <div class="col">
          <label for="cid" class="form-label">CID</label>
          <div class="input-group">
            <span class="input-group-text"><i class="bi bi-filter"></i></span>
            <input type="text" class="form-control" [(ngModel)]="filters['cid']" [ngModelOptions]="{standalone: true}">
          </div>
        </div>

        <div class="col">
          <label for="filter-event-id" class="form-label">Event</label>
          <div class="input-group">
            <span class="input-group-text"><i class="bi bi-filter"></i></span>
            <app-dropdown-select [multiple]="true" [(ngModel)]="filters['name']" [ngModelOptions]="{standalone: true}">
              @for (eventName of eventNameList; track eventName) {
                <app-dropdown-select-option [value]="eventName">{{ eventName }}
                </app-dropdown-select-option>
              }
            </app-dropdown-select>
          </div>
        </div>

        <div class="col">
          <label for="filterStatus" class="form-label">Status</label>
          <div class="input-group">
            <span class="input-group-text"><i class="bi bi-list-task"></i></span>
            <select class="form-select" id="filterStatus" [(ngModel)]="filters['status']">
              <option [ngValue]="null">All status</option>
              @for (status of statusList; track status) {
                <option [value]="status" class="text-capitalize">{{ status }}</option>
              }
            </select>
          </div>
        </div>

        <div class="col-auto ms-auto">
          <button (click)="downloadCsv()" [disabled]="downloading" class="btn btn-secondary fw-bold">
            @if (downloading) {
              <app-csv-export-progress [current]="exportProgress?.current ?? 0"
                                       [total]="exportProgress?.total ?? 0">
              </app-csv-export-progress>
            } @else {
              CSV
            }
          </button>
        </div>

        <div class="col-auto ms-auto">
          <button type="submit" class="btn btn-primary fw-bold" (click)="applyFilters()">Apply Filters</button>
        </div>
      </div>

      <app-display-table-column [data]="displayedColumns"></app-display-table-column>

      <div class="table-responsive">
        <table class="table table-striped table-hover table-fixed-columns my-4" id="conversion-events">
          <thead>
            <tr [tableSorter]="tableSorter" (tableSorterChange)="fetchAll()">
              <th tableSorterHeader="id">ID</th>
              <th tableSorterHeader="createdAt">Date</th>
              <th>Partner</th>
              <th>Event</th>
              <th>Event ID</th>
              <th>Platform</th>
              @if (displayedColumns.clickid) {
                <th>Click ID</th>
              }
              @if (displayedColumns.lead) {
                <th>Lead ID</th>
              }
              @if (displayedColumns.conversion) {
                <th>Conversion ID</th>
              }
              @if (displayedColumns.amount) {
                <th>Amount</th>
              }
              <th>Status</th>
              <th class="action-header">Details</th>
            </tr>
          </thead>
          <tbody>
            @for (conversionEvent of conversionEvents; track conversionEvent) {
              <tr>
                <td>{{ conversionEvent.id }}</td>
                <td>{{ conversionEvent.createdAt | parisDate }}</td>
                <td>{{ conversionEvent.partner }}</td>
                <td>{{ conversionEvent.name }}</td>
                <td>{{ conversionEvent.eventId }}</td>
                <td>{{ conversionEvent.advertisingPlatform }}</td>
                @if (displayedColumns.clickid) {
                  <td><a href="javascript:void(0)"
                  (click)="openClickDetail(conversionEvent)">{{ conversionEvent.clickId }}</a>
                </td>
              }
              @if (displayedColumns.lead) {
                <td><a href="javascript:void(0)"
                (click)="openLeadDetail(conversionEvent)">{{ conversionEvent.leadId }}</a>
              </td>
            }
            @if (displayedColumns.conversion) {
              <td><a href="javascript:void(0)"
              (click)="openConversionDetail(conversionEvent)">{{ conversionEvent.conversionId }}</a>
            </td>
          }
          @if (displayedColumns.amount) {
            <td
              >{{ conversionEvent.amount | money:2:$safeNavigationMigration(conversionEvent.currency?.isoCode) }}
            </td>
          }
          <td><span class="badge rounded-pill"
          [ngClass]="getStatusClass(conversionEvent.advertisingPlatformStatus)">{{ conversionEvent.advertisingPlatformStatus }}</span>
        </td>
        <td>
          <button type="button" class="btn btn-primary fw-bold btn-sm"
            (click)="toggleConversionEvent(conversionEvent)"
            [disabled]="!conversionEvent.advertisingPlatformResult">
            <i
            class="bi bi-eye-fill"></i></button>
          </td>
        </tr>
        @if (openConversionEvent===conversionEvent) {
          <tr>
            <td colspan="8">
              <pre class="result" [innerHTML]="openConversionEvent.advertisingPlatformResult"></pre>
            </td>
          </tr>
        }
      }
    </tbody>
  </table>
</div>

<app-paginator (pageChange)="fetchAll()" [paginator]="paginator"></app-paginator>
</div>
</div>
